module.exports = __webpack_public_path__ + "static/media/June_2026_4.fc7c007e.webp";